<div class="container-fluid">
  <app-header titleText="Support Faqs">
  </app-header>
  <div class="card bg-light">
    <div class="card-header">
      <h3>FAQ</h3>
      <div>
        FAQ define common categories and content about functionality in the Bidit Application. Items defined here will appear in the Bidit support page.
      </div>
      <div *ngIf="this.faqs" class="card-body">
        <div class="form-inline float-right mb-2">
          <div>
            <select name="supportFaq_Locale" class=" mr-5 form-control select-bidit" [(ngModel)]="this.locale" (ngModelChange)="loadFaqs()">
              <option value="en">English</option>
              <option value="es">Español</option>
            </select>
          </div>
          <div class="float-right">
            <button (click)="showEdit(null)" class="btn btn-bidit-navigate btn-sm">Add</button>
          </div>
        </div>
        <div class="clearfix"></div>

        <mat-table class="table table-bidit table-hover" [dataSource]="this.dataSource"
                   cdkDropList
                   [cdkDropListData]="this.dataSource"
                   (cdkDropListDropped)="drop($event)">
          <!-- Position Column -->
          <ng-container matColumnDef="position">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style="pointer-events: all;"
                        cdkDragHandle>reorder</mat-icon>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="supportFaq_Locale">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Locale: {{locale}}</mat-header-cell>
          </ng-container>
          <ng-container matColumnDef="supportFaq_Title">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Category</mat-header-cell>
            <mat-cell *matCellDef="let faq">
              <div [innerHTML]="faq.supportFaq_Title"></div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="supportFaq_Content">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Content</mat-header-cell>
            <mat-cell *matCellDef="let faq">
              <div [innerHTML]="faq.supportFaq_Content"></div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="supportFaq_Hyperlink">
            <mat-header-cell *matHeaderCellDef m class="bidit-header" i18n>Link</mat-header-cell>
            <mat-cell *matCellDef="let faq">
              <div>
                <div *ngFor="let hyperlink of faq.hyperlinks">
                  <div>{{hyperlink.supportFaqHyperlink_Description}}</div>
                  <div>{{hyperlink.supportFaqHyperlink_Path}}</div>
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n></mat-header-cell>
            <mat-cell class="float-end" *matCellDef="let faq">
              <a class="btn btn-bidit-edit-dark mr-2" (click)="showEdit(faq.supportFaq_ID)"> </a>
              <a class="btn btn-bidit-delete mr-2" (click)="deleteFaq(faq.supportFaq_ID)"></a>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns">
          </mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag [cdkDragData]="row"></mat-row>
        </mat-table>

        <mat-paginator [length]="this.faqs.length" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
